(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeHeaderDeleteController',HandbookMergeHeaderDeleteController);

    HandbookMergeHeaderDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookMergeHeader'];

    function HandbookMergeHeaderDeleteController($uibModalInstance, entity, HandbookMergeHeader) {
        var vm = this;

        vm.handbookMergeHeader = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookMergeHeader.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
